<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan" :gutter="20">
      <el-col :span="14">
        <el-button icon="el-icon-plus" @click="addUser">新增</el-button>
      </el-col>
      <el-col :span="5">
        <search-input v-model="queryInfo.brief" placeholder="请输入备注进行搜索" @change="handleQuery"/>
      </el-col>

      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 70px)'" :data="userList" class="button-box">
      <el-table-column label="账号" prop="username" />
      <el-table-column label="用户名字" prop="name" />
      <el-table-column label="头像">
        <template slot-scope="scope">
          <img style="width: 45px;height: 45px;" :src="scope.row.photo" alt="">
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="brief"></el-table-column>
      <el-table-column label="电话" prop="phone" />
      <el-table-column label="是否会员" prop="address">
        <template slot-scope="scope">{{scope.row.vip === 'YES' ? '会员' : ''}}</template>
      </el-table-column>
      <el-table-column label="用户角色" prop="enumType">
        <template slot-scope="scope">{{ scope.row.enumType | userEnumType}}</template>
      </el-table-column>
      <el-table-column label="用户邮箱" prop="email" :show-overflow-tooltip='true' />
      <el-table-column label="积分" prop="integral" />
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{scope.row.enumStatus === 'NORMAL' ? '启用' : '禁用'}}
        </template>
      </el-table-column>
      <el-table-column label="用户排序" prop="sort" />
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button icon="el-icon-edit" @click="edtiUser(scope.row)">修改</el-button></div>
              <div><el-button icon="el-icon-delete" @click="removeUserById(scope.row.id)">删除</el-button></div>
              <div><el-button @click="updateIntegrated(scope.row)">发放积分</el-button></div>
              <div><el-button @click="lookIntegrated(scope.row)">查看积分</el-button></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync="queryInfo" @pagination="getUserList" /></div>

    <addUser @refresh-list="handleQuery" ref="addUser"></addUser>
    <editUser @refresh-list="handleQuery" ref="editUser"></editUser>

    <!--发放积分-->
    <order-integral @refresh-list="handleQuery" ref="orderIntegral"></order-integral>

    <!--查看积分列表-->
    <look-integrated ref="lookIntegrated"></look-integrated>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addUser from '@/views/user/addUser'
import editUser from '@/views/user/editUser'
import { deleteUser, getUserList } from '@/api/user/user'
import { deleteTips, title } from '@/utils/tips'
import { getPostOrDeleteData } from '@/utils/code'
import OrderIntegral from '@/components/common/orderIntegral/orderIntegral'
import lookIntegrated from '@/views/user/lookIntegrated'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  components: { SearchInput, Pagination, addUser, editUser, OrderIntegral, lookIntegrated },
  data() {
    return {
      queryInfo: {
        keyword: '',
        brief: '',
        roleKey: 'ADMIN'
      },
      userList: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    /**
     * 查询列表
     */

    getUserList(page, cb) {
      getUserList(page).then(res => {
        this.userList = cb(res)
      })
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //确认积分弹窗
    updateIntegrated(row) {
      let data = {
        userId: row.id
      }
      this.$refs.orderIntegral.editDialog(data)
    },

    /**
     * 根据ID删除数据
     */
    async removeUserById(id) {
      let b = await deleteTips(title.deleteTitle)
      if (b) {
        deleteUser(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }
    },

    /**
     * 新增
     */
    addUser() {
      this.$refs.addUser.addDialog()
    },
    /**
     *  修改
     */
    edtiUser(row) {
      this.$refs.editUser.editDialog(row)
    },
    lookIntegrated(row) {
      this.$refs.lookIntegrated.lookDialog(row)
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}
</style>
